import React, { Component } from "react";
import { connect } from "react-redux";
// import Drag from '../../campaign/dragNdDropKycFile';
import { putServerDataWithPath } from "../../../action/common_action";
import { domain, fileUrl, endPoints } from "../../../config";
import { EditorState, convertToRaw } from "draft-js";
import Editor from "draft-js-plugins-editor";
import createToolbarPlugin, { Separator } from "draft-js-static-toolbar-plugin";
import {
  ItalicButton,
  BoldButton,
  UnderlineButton,
  CodeButton,
  HeadlineOneButton,
  HeadlineTwoButton,
  HeadlineThreeButton,
  UnorderedListButton,
  OrderedListButton,
  BlockquoteButton,
  CodeBlockButton,
} from "draft-js-buttons";
import { stateFromHTML } from "draft-js-import-html";
import "draft-js-static-toolbar-plugin/lib/plugin.css";
import "draft-js/dist/Draft.css";
import draftToHtml from "draftjs-to-html";
import { axiosInstnace as axios } from "../../../util/util";

import { ANY_ERROR } from "../../../action/user_action_types";
const staticToolBarPlugin = createToolbarPlugin();
const ToolbarStatic = staticToolBarPlugin.Toolbar;

class HeadlinesPicker extends Component {
  componentDidMount() {
    setTimeout(() => {
      window.addEventListener("click", this.onWindowClick);
    });
  }

  componentWillUnmount() {
    window.removeEventListener("click", this.onWindowClick);
  }

  onWindowClick = () =>
    // Call `onOverrideContent` again with `undefined`
    // so the toolbar can show its regular content again.
    this.props.onOverrideContent(undefined);

  render() {
    const buttons = [HeadlineOneButton, HeadlineTwoButton, HeadlineThreeButton];
    return (
      <div>
        {buttons.map((
          Button,
          i // eslint-disable-next-line
        ) => (
          <Button key={i} {...this.props} />
        ))}
      </div>
    );
  }
}

class HeadlinesButton extends Component {
  onClick = () =>
    // A button can call `onOverrideContent` to replace the content
    // of the toolbar. This can be useful for displaying sub
    // menus or requesting additional information from the user.
    this.props.onOverrideContent(HeadlinesPicker);

  render() {
    return (
      <div className="headlineButtonWrapper">
        <button onClick={this.onClick} className="headlineButton">
          H
        </button>
      </div>
    );
  }
}

class MessagePopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      audio_file: null,
      audio_duration: 0,
      editor: "",
      plugins: [staticToolBarPlugin],
      audioBrief: EditorState.createWithContent(
        stateFromHTML(props.campaignDetails.message)
      ),
      styles: {
        editor: {
          height: "300px",
          overflow: "auto",
          width:"100%",
          fontWeight:"normal"
        },
      },
    };
    
    if (props.type == "update") {
      this.state.styles.editor["border"] = "1px solid gray";
    }
    if (
      !props.campaignDetails.message ||
      props.campaignDetails.message.trim() == ""
    ) {
      this.state.audioBrief = EditorState.createWithContent(
        stateFromHTML("Not Available")
      );
    }
    console.log(this.state.static);
  }


  setEditorState = (editor) => {
    this.setState({ editor });
    console.log(this.state.editor);
  };

  focusEditor = () => {
    if (this.state.editor) {
      this.state.editor.focus();
    }
  };


  render() {
    return (
      <div>
        <div className="modal-overlay">
          <div
            className="modal-wrapper thankyou-popup"
            aria-modal
            aria-hidden
            tabIndex={-1}
            role="dialog"
          >
            <div
              className="modal modal-brief"
              style={{ width: "100% !important" }}
            >
              <div className="modal-head-cross rate-modal">
                <button
                  type="button"
                  className="modal-close-button"
                  onClick={() => this.props.hideAudioBrief()}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="editNonFct-header modal-header">
                  <h4 className="popup-head rqst-head fct-head modal-title">
                    Message
                  </h4>
                </div>
                <div className="editNonFct-modal modal-body">
                  <div className="bg-white">
                    <form className="form-group">
                      <div className="popupCampaign-container">
                        <div className="campaign-input master-inputs nonFct">
                          <div className="lenght_file_wrapper">
                            <div className="flie_audio">
                             
                                  <div
                                    style={this.state.styles.editor}
                                    onClick={this.focusEditor}
                                  >
                                    <Editor
                                      ref={this.setEditorState}
                                      editorState={this.state.audioBrief}
                                      readOnly="true"
                                    />
                                  </div>
                  
                            
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    showError: (error) =>
      dispatch({
        type: ANY_ERROR,
        payload: error,
      }),
    updateAudioToCampaign: (url, data, path) =>
      dispatch(putServerDataWithPath(url, data, path)),
  };
};

export default connect(null, mapDispatchToProps)(MessagePopup);



// WEBPACK FOOTER //
// ./web/components/admin/manageNotification/MessagePopup.js